import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import Login from '../views/users/Login.vue'
import PrintMatricial from '../views/home/PrintMatricial.vue'
import PrintTermica from '../views/home/PrintTermica.vue'
import Fonts from '../views/fonts/Fonts.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/printMatricial',
      name: 'printMatricial',
      meta: { title: 'Impressão' },
      component: PrintMatricial
    },
    {
      path: '/printTermica',
      name: 'printTermica',
      meta: { title: 'Impressão' },
      component: PrintTermica
    },
    {
      path: '/fonts',
      name: 'fonts',
      meta: { title: 'Fontes' },
      component: Fonts
    },
    {
      path: '/legislation',
      name: 'legislation',
      meta: { title: 'Legislação' },
      component: () => import('../views/legislation/Legislation')
    },
    {
      path: '/productsList',
      name: 'productsList',
      meta: { title: 'Lista de Produtos' },
      component: () => import('../views/products/ProductsList')
    },
    {
      path: '/products',
      name: 'products',
      meta: { title: 'Produtos' },
      component: () => import('../views/products/Products')
    },
    {
      path: '/contact',
      name: 'contact',
      meta: { title: 'Contato' },
      component: () => import('../views/contact/Contact')
    },
    {
      path: '/users',
      name: 'users',
      meta: { title: 'Controle de Usuários' },
      component: () => import('../views/users/Users')
    },
    {
      path: '/requests',
      name: 'requests',
      meta: { title: 'Pedidos de Venda' },
      component: () => import('../views/requests/Requests')
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      meta: { title: 'Política de Privacidade' },
      component: () => import('../views/users/PrivacyPolicy')
    },
    {
      path: '/adverts',
      name: 'adverts',
      meta: { title: 'Anúncios' },
      component: () => import('../views/adverts/Adverts')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - Gravi Águas`
  } else {
    document.title = 'Gravi Águas'
  }

  if (!window.uid && to.name !== 'login' && to.name !== 'privacypolicy') {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
